import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Poi } from './poi/poi.service';

@Injectable({
  providedIn: 'root'
})
export class MetaService {

  constructor(
    private titleService: Title,
    private meta: Meta
    ) { }

  setTitle(title: string) {
    this.titleService.setTitle(title);
  }

  setTags(keywords: string, description: string) {
    this.meta.addTags([
      { name: "keywords", content: `Seeguide, Attersee, ${keywords}` },
      { name: "description", content: description },
      { name: 'robots', content: 'index, follow' }
    ]);
  }

  setDetailTitle(poi: Poi) {
    // console.log(`Title: ${this.getCategoryName(poi.category, true)} ${poi.name} in ${poi.municipality} | Seeguide.at`);
    // console.log(`description: ${poi.description.substr(0, 150)}`);
    this.titleService.setTitle(`${this.getCategoryName(poi.category, true)} ${poi.name} in ${poi.municipality} | Seeguide.at`);
    this.meta.addTags([
      { name: "keywords", content: `Seeguide, Attersee, ${poi.category}, ${poi.municipality}, ${poi.tags}` },
      { name: "description", content: poi.description.substr(0, 150) },
      { name: 'robots', content: 'index, follow' }
    ]);
  }

  setListTitle(category?: string, municipality?: string) {
    let place = municipality != null ? `in ${municipality}` : `am Attersee`;
    this.titleService.setTitle(`${this.getCategoryTitle(category)} ${place} | Seeguide.at`); 
    this.meta.addTags([
      { name: "keywords", content: `Seeguide, Attersee, ${this.getCategoryTitle(category)}, ${place}` },
      { name: "description", content: `${this.getCategoryTitle(category)} ${place} mit vielen Bildern und User Bewertungen.` },
      { name: 'robots', content: 'index, follow' }
    ]);   
  }

  getCategoryName(category: string, singular = false): string{
    switch(category.toLowerCase()){
      case "restaurant":
        return singular ? "Restaurant" : "Restaurants";
      case "badeplatz":
        return singular ? "Badeplatz" : "Badeplätze";
      case "wanderung":
        return singular ? "Ausflug" : "Ausflüge";
      default: 
        return "";
    }
  }

  getCategoryTitle(category?: string){
    if (!category) {
      return "Top Badeplätze, Restaurants und Ausflüge"
    }
    switch(category.toLowerCase()){
      case "restaurant":
        return "Die besten Restaurants";
      case "badeplatz":
        return "Die schönsten Badeplätze";
      case "wanderung":
        return "Die schönsten Ausflüge";
      default:
        return "Top Badeplätze, Restaurants und Ausflüge";
    }
  }

  getCategoryUrl(category: string): string{
    switch(category.toLowerCase()){
      case "restaurant":
        return "restaurants";
      case "badeplatz":
        return "badeplaetze";
      case "wanderung":
        return "ausfluege";
      default:
        return ""
    }
  }

  slugify(urlString: string) {
    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')
  
    return urlString.toString().toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, '-and-') // Replace & with 'and'
      .replace(/[^\w\-]+/g, '') // Remove all non-word characters
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
  }
}
